
import type { PropType } from 'vue'

import type { DispatcherWorkplaceRecord } from '@/modules/DispatcherWorkplaceModule/types'
import type { ClusterFeature } from '@/modules/YandexMap3Module/map-cluster.types'

import { defineComponent } from 'vue'

import DwRecordPopupFeature from '@/modules/DispatcherWorkplaceModule/components/DwRecordPopupFeature/index.vue'

type ClusterFeatureRecord = {
    record: DispatcherWorkplaceRecord
}

export default defineComponent({
    components: {
        DwRecordPopupFeature
    },
    props: {
        feature: {
            type: Object as PropType<ClusterFeature<ClusterFeatureRecord>>,
            required: true
        },
    },
    emits: [
        'close',
        'change-date',
        'add-to-wait-list',
        'assign',
        'self-delivery'
    ],
    setup(props, { emit }) {
        const onClose = () => {
            emit('close')
        }

        const onChangeDate = (feature: ClusterFeature<ClusterFeatureRecord>) => {
            emit('change-date', feature)
        }

        const onAddToWaitList = (feature: ClusterFeature<ClusterFeatureRecord>) => {
            emit('add-to-wait-list', feature)
        }

        const onAssign = (feature: ClusterFeature<ClusterFeatureRecord>) => {
            emit('assign', feature)
        }

        const onSelfDelivery = (feature: ClusterFeature<ClusterFeatureRecord>) => {
            emit('self-delivery', feature)
        }

        return {
            onClose,
            onChangeDate,
            onAddToWaitList,
            onAssign,
            onSelfDelivery,
        }
    }
})
